import agendaApiConfig from "./agendaApiConfig";

const CovenantsService = {
    async getAll() {
        return await agendaApiConfig.get("/prevision");
    }
}

export default CovenantsService;